import React from 'react';
import { GlobalFilterState } from '../GlobalFilterState';
import { RadioButtonChangeEvent } from '@progress/kendo-react-inputs';
import { Calendar, CalendarProps, MultiViewCalendar, MultiViewCalendarProps } from '@progress/kendo-react-dateinputs';
import { DateTimeFieldPicker } from './DateTimeFieldPicker';
import { GEAR_FIELD_TYPE } from '../../../../../global/enums/GearFieldType';

interface UnifiedCalendarProps {
  dateFiltersState: GlobalFilterState[];
  fieldSelected: GlobalFilterState;
  handleFieldChange: (event: RadioButtonChangeEvent) => void;
  calendarProps: CalendarProps | MultiViewCalendarProps;
}

export const UnifiedCalendar: React.FC<UnifiedCalendarProps> = props => {
  const { dateFiltersState, fieldSelected, handleFieldChange, calendarProps } = props;

  return (
    <div className="dateTimeCalendar">
      <DateTimeFieldPicker
        dateFiltersState={dateFiltersState}
        fieldSelected={fieldSelected}
        handleFieldChange={handleFieldChange}
      />

      {fieldSelected.type === GEAR_FIELD_TYPE.DATETIME ? (
        <Calendar {...(calendarProps as CalendarProps)} />
      ) : (
        <MultiViewCalendar {...(calendarProps as MultiViewCalendarProps)} />
      )}
    </div>
  );
};
